import { beesafeTheme } from '@sky-distribution/react-commons-ui';

const getRatio = (vertical: boolean): string => (vertical ? 'height' : 'width');

const mediaBetween = (
  vertical: boolean,
  breakpointMin: number,
  breakpointMax: number,
): string => `(max-${getRatio(
  vertical,
)}: ${breakpointMax}px) and (min-${getRatio(
  vertical,
)}: ${breakpointMin + 0.02}px)`;

export const commonTheme = {
  up: (
    breakpoint: number, vertical = false,
  ): string => `@media (min-${getRatio(vertical)}: ${breakpoint + 0.02}px)`,
  down: (
    breakpoint: number, vertical = false,
  ): string => `@media (max-${getRatio(vertical)}: ${breakpoint}px)`,
  between: (
    breakpointMin: number,
    breakpointMax: number,
    vertical = false,
  ): string => `@media ${mediaBetween(vertical, breakpointMin, breakpointMax)}`,
  breakpoints: {
    xs: 0,
    sm: 600,
    smd: 800,
    md: 960,
    lg: 1280,
    xl: 1408,
  },
};

export const theme = {
  ...beesafeTheme,
  ...commonTheme,
};
